import { PlanEstudioI } from "interfaces/PlanEstudio";
import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";

interface Props {
  onClose?: any;
  elemento: PlanEstudioI | null;
  showModal: boolean;
}

export const PlanesDetailModal = ({ elemento, showModal, onClose }: Props) => {
  const [fullElement, setFullElement] = useState<PlanEstudioI>();
  const [isLoading, setIsLoading] = useState(false);

  const getFullElement = () => {
    try {
    } catch (err) {}
  };

  useEffect(() => {
    if (showModal) {
    }
  }, [showModal]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="xl" centered>
        <Modal.Header>
          <Modal.Title>{"Detalle plan estudio:"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col>
            <Row>
              <Col sm={6} lg={4} className="mb-4">
                <b>Nombre:</b> <br></br>
                {elemento?.nombre}
              </Col>

              <Col sm={6} lg={4} className="mb-4">
                <b>Cantidad de años:</b> <br></br>
                {elemento?.cantidad_anios}
              </Col>

              <Col sm={6} lg={4} className="mb-4">
                <b>Alcance:</b> <br></br>
                {elemento?.alcance.nombre}
              </Col>

              <Col sm={6} lg={4} className="mb-4">
                <b>Fecha de publicación:</b> <br></br>
                {elemento?.fecha_publicacion &&
                  formatDate.stringDate(elemento?.fecha_publicacion)}
              </Col>

              <Col lg={4} className="mb-4">
                <b>Descripcion:</b> <br></br>
                {elemento?.descripcion}
              </Col>

              <hr></hr>

              <Col sm={6} className="mb-4">
                <b>Diseño curricular:</b> <br></br>
                {elemento?.disenio_curricular.nombre}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Orientaciones:</b> <br></br>
                {elemento?.orientaciones.map((ctOr) => ctOr.nombre).join(" - ")}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Normativas:</b> <br></br>
                {elemento?.normativas.map((ctOr) => ctOr.nombre).join(" - ")}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Títulos:</b> <br></br>
                {elemento?.titulos.map((ctOr) => ctOr.nombre).join(" - ")}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Certificaciones:</b> <br></br>
                {elemento?.certificaciones
                  .map((ctOr) => ctOr.nombre)
                  .join(" - ")}
              </Col>

              <Col sm={6}>
                <b>Especialidades:</b> <br></br>
                {elemento?.especialidades
                  .map((ctOr) => ctOr.nombre)
                  .join(" - ")}
              </Col>

              <Col sm={6}>
                <b>Nivel - Modalidad - Opción pedagógica:</b> <br></br>
                <ul style={{ paddingLeft: "18px" }}>
                  {elemento?.combinatorias.map((ctComb) => (
                    <li key={`combinatoria-${ctComb.id}`}>
                      {ctComb.nivel.nombre} - {ctComb.modalidad.nombre} -{" "}
                      {ctComb.opcion_pedagogica.nombre}
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="mx-3"
            variant="secondary"
            size="lg"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
